/* src/app/dialogs/crm-relation-editor/crm-relation-editor.component.css */
/*# sourceMappingURL=crm-relation-editor.component-5S7V2EWL.css.map */
